import { render } from "./index.vue?vue&type=template&id=7c2d3c10"
import script from "./script.js?vue&type=script&lang=js"
export * from "./script.js?vue&type=script&lang=js"
script.render = render

export default script